// CRUD ACTIONS
export const CREATE = "CREATE"
export const UPDATE = 'UPDATE';
export const DELETE = 'DELETE';
export const GET_LIKE = 'GET_LIKE'; 
export const LIKE = 'LIKE'; 
export const EDIT = 'EDIT'; 

// BLOG ACTIONS
export const GET_ONE_POST = "GET_ONE_POST";
export const GET_ALL_POSTS = "GET_ALL_POSTS";
export const GET_POST_EDIT = "GET_POST_EDIT";

// JOB ACTIONS 
export const GET_JOBS_ALL = "GET_JOBS_ALL";
export const GET_JOBS_EDIT = "GET_JOBS_EDIT";
export const GET_JOBS_SAVED = "GET_JOBS_SAVED";
export const SELECTED_JOB = "SELECTED_JOB";
export const SAVE = 'SAVE';
export const REMOVE_SAVED_JOB = "REMOVE_SAVED_JOB";

// LOGIN ACTIONS
export const LOGIN ="LOGIN";
export const LOGOUT = 'LOGOUT';

// MENTORING ACTIONS
//getting data from the forms
export const ADD_MENTOR = "ADD_MENTOR";
export const ADD_MENTEE = "ADD_MENTEE";

//rendering all mentors in a page
export const GET_ALL_MENTORS = "GET_ALL_MENTORS"
